import { Autocomplete, Backdrop, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
import {  Delete, EditNote } from "@mui/icons-material";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const MemberList = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [active, setActive] = useState(false)
  const [isLoader, setIsLoader] = useState(false); //loader
     const [status,setStatus] =useState()
 
  const validationSchema = yup.object({
    mobile : yup.string().required("Mobile No is required"),
    // partyname: yup.string().required("Name is required field")
    partyname: yup.string()
    .required("Name is a required field")
    .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed for this field"),
  })
  
  const formik = useFormik({
    initialValues :{
        mobile : "",
      partyname:"",
      address:"",
      spousename:"",
      noofchild:null,
      partydob:null,
      anniversaryDate:null,
      spousedob:null,
      balpoint:null
    },
    validationSchema:validationSchema,
    onSubmit: isEdit ? handleUpdate : handleCreate
  })
  const onCreate = () => {
    setOpen(true)
    formik.resetForm()
    setIsEdit(false)
  }
  function handleCreate(){
    const payload = {
      is_active : active,
        mobile: formik.values.mobile,
        party_name: formik.values.partyname,
        address: formik.values.address,
        spouse_name: formik.values.spousename,      
        no_of_child: formik.values.noofchild,
        balance_points: formik.values.balpoint,
        spouse_dob: formik.values.spousedob
        ? dayjs(formik.values.spousedob).format('YYYY-MM-DD')
        : null, // Convert anniversary date to YYYY-MM-DD format
        anniversary_date: formik.values.anniversaryDate
        ? dayjs(formik.values.anniversaryDate).format('YYYY-MM-DD')
        : null, // Convert anniversary date to YYYY-MM-DD format
        party_dob: formik.values.partydob
        ? dayjs(formik.values.partydob).format('YYYY-MM-DD')
        : null, // Convert anniversary date to YYYY-MM-DD format
    }

    setIsLoader(true);
    axios.post('v1/outlet/member', payload)
    .then(res=>{
      console.log(res)
      setOpen(false)
      getUomData()
      setIsLoader(false);
      dispatch(setSnackbar(true, 'success', 'Created Successfully'))
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      console.log(err)
      setIsLoader(false);
    })
  }
  function onEdit(e){
    console.log(e)
    formik.setFieldValue('mobile',e.mobile)
    formik.setFieldValue('partyname',e.party_name)
    formik.setFieldValue('address',e.address)
    formik.setFieldValue('spousename',e.spouse_name)
    formik.setFieldValue('noofchild',e.no_of_child)
    formik.setFieldValue('balpoint',e.balance_points)
    formik.setFieldValue('spousedob', e.spouse_dob 
        ? dayjs(e.spouse_dob).format('YYYY-MM-DD') 
        : ''
    );
    formik.setFieldValue('partydob', e.party_dob 
        ? dayjs(e.party_dob).format('YYYY-MM-DD') 
        : ''
    );
    formik.setFieldValue('anniversaryDate', e.anniversary_date 
        ? dayjs(e.anniversary_date).format('YYYY-MM-DD') 
        : ''
    );
    setIsEdit(true)
    setOpen(true)
    setActive(e.isActive)
    setActiveId(e.id)
    }
    function handleUpdate(){
        const payload = {
          is_active : active,
            mobile: formik.values.mobile,
            party_name: formik.values.partyname,
            address: formik.values.address,
            spouse_name: formik.values.spousename,      
            no_of_child: formik.values.noofchild,  
            balance_points: formik.values.balpoint,
            spouse_dob: formik.values.spousedob
            ? dayjs(formik.values.spousedob).format('YYYY-MM-DD')
            : null, // Convert anniversary date to YYYY-MM-DD format
            anniversary_date: formik.values.anniversaryDate
            ? dayjs(formik.values.anniversaryDate).format('YYYY-MM-DD')
            : null, // Convert anniversary date to YYYY-MM-DD format
            party_dob: formik.values.partydob
            ? dayjs(formik.values.partydob).format('YYYY-MM-DD')
            : null, // Convert anniversary date to YYYY-MM-DD format
        }
      setIsLoader(true);
      axios.put(`/v1/outlet/member/${activeId}`, payload)
      .then(res=>{
        setOpen(false)
        console.log(res)
        getUomData()
        setIsLoader(false);
        dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('update')
    }
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    const handleDelete = () =>{
      setIsLoader(true);
      axios.delete(`/v1/outlet/member/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getUomData()
        console.log(res)
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
        setIsLoader(false);
        setOpen(false)
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('fasdf')
    }
  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 1,
      minWidth: 70,
      // maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
      minWidth: 70,
      // maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "mobile",
      headerName: "Mobile No",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "party_name",
      headerName: "Name",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "party_dob",
      headerName: "DOB",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "address",
      headerName: "Address",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "spouse_name",
      headerName: "Spouse Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "spouse_dob",
      headerName: "Spouse Dob",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },

    {
      field: "anniversary_date",
      headerName: "Anniversary Date",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "no_of_child",
      headerName: "No of Child",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "balance_points",
      headerName: "Bal Point",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
     {
               field: "active",
               headerName: "Status",
               flex: 1,
               headerAlign: "center",
               align: "center",
               minWidth: 100,
               disableExport: true ,
               sortable: false,
               disableColumnMenu: true,
               renderCell: (params) => (
                 <div className="">
                    <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
                 </div>
               )
             },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      disableExport: true ,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"black",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];
  const rows = _.map(data, (val,idx) => ({
    id:val.id,
    sno:++idx,
    mobile:val.mobile,
    party_name:val.party_name,
    party_dob:val.party_dob ,
    address:val.address || "-",
    spouse_name:val.spouse_name || "-",
    spouse_dob: val.spouse_dob,
    anniversary_date: val.anniversary_date,
    no_of_child:val.no_of_child ,
    balance_points:val.balance_points || "0",
    isActive: val.is_active,

  }))
  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  const getUomData = () =>{
    setIsLoader(true);
    // const url = `/v1/outlet/member/${rowsPerPage}/${page + 1}`
    // const searchUrl = `/v1/outlet/member/${rowsPerPage}/${page + 1}/${search}`
    // axios.get(search === '' ? url : searchUrl)
    const approvestatus = status ? (status.id === 0 ? 0 : status.id) : 0; // 0: All, 1: Generated, 2: Verified
       
    axios.get(`/v1/outlet/member/${rowsPerPage}/${page + 1}?status=${approvestatus}&search=${search}`)
    .then(res=>{
      setData(res.data.data)
      setPageCount(res.data.meta.pagination.total)
      setIsLoader(false);
    })
    .catch(err=>{
      setData([])
      console.log(err)
      setIsLoader(false);
      dispatch(setSnackbar(true, 'error', err.response.data.error))
    })
  }
      function handleChange(e, name) {
        // setProdDate(prev=>({...prev,[name] : dayjs(e).format() }))
      }
  useEffect(()=>{
    getUomData()
    },[rowsPerPage, page, search,status])
    console.log(data)
  return (
    <Grid className="">
      <Helmet>
        <title>Customer /Members List</title>
      </Helmet>
      <Typography variant="h5">Customer /Members List</Typography>
           <Grid container spacing={2} className="p-2 pt-2">
             
        <Grid item md={3}>
                 <Autocomplete
                   size="small"
                   options={[
                     { id: 0, fullname: "All" },
                     { id: 1, fullname: "Active" },
                     { id: 2, fullname: "Inactive" },
                   ]}
                   disableClearable
                   value={status}
                   onChange={(e, value) => setStatus(value)} // Update status
                   getOptionLabel={(option) => option.fullname}
                   renderInput={(params) => <TextField {...params} placeholder="Select Status" />}
                 />
               </Grid>
               </Grid>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
 {open &&
        <Modal onClose={setOpen} formik={formik} onSave={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <CustomTextField id='mobile' value={formik.values.mobile} title='Mobile No' multiple={false} placeholder='Enter Mobile No' onchange={formik.handleChange} errorMsg={formik.touched.mobile && Boolean(formik.errors.mobile)} helperText={formik.touched.mobile && formik.errors.mobile}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <CustomTextField id='partyname' value={formik.values.partyname} title='Name' multiple={false} placeholder='Enter Name' onchange={formik.handleChange} errorMsg={formik.touched.partyname && Boolean(formik.errors.partyname)} helperText={formik.touched.partyname && formik.errors.partyname}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            {/* <Typography variant="h12">DOB</Typography> */}
            <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
    DOB
  </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
          
            value={formik.values.partydob ? dayjs(formik.values.partydob) : null}
              onChange={(date) => {
                const formattedDate = date ? date.toISOString().split("T")[0] : null; // Extract only the date part
                formik.setFieldValue("partydob", formattedDate); // Update Formik field with the formatted date
              }}
              
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                //   label:'DOB',
                  style:{width : '100%',marginBlock:2}
                },
              }}
            />
          </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
             <CustomTextField id="address" value={formik.values.address} title="Address" multiple={false} placeholder="Enter address" onchange={formik.handleChange} errorMsg={ formik.touched.address &&  Boolean(formik.errors.address) } helperText={formik.touched.address && formik.errors.address}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
             <CustomTextField id="spousename" value={formik.values.spousename} title="Spouse Name" multiple={false} placeholder="Enter spousename" onchange={formik.handleChange} errorMsg={ formik.touched.spousename &&  Boolean(formik.errors.spousename) } helperText={formik.touched.spousename && formik.errors.spousename}/>
            </Grid>
             
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            {/* <Typography variant="h12">Spouse DOB</Typography> */}
            <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
            Spouse DOB
  </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={formik.values.spousedob ? dayjs(formik.values.spousedob) : null}
            onChange={(date) => {
                const formattedDate = date ? date.toISOString().split("T")[0] : null; // Extract only the date part
                formik.setFieldValue("spousedob", formattedDate); // Update Formik field with the formatted date
              }}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                //   label:'Spouse DOB',
                  style:{width : '100%',marginBlock:2}
                },
              }}
            />
          </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
            Anniversary Date
  </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
             value={formik.values.anniversaryDate ? dayjs(formik.values.anniversaryDate) : null}
                        onChange={(date) => {
                            const formattedDate = date ? date.toISOString().split("T")[0] : null; // Extract only the date part
                            formik.setFieldValue("anniversaryDate", formattedDate); // Update Formik field with the formatted date
                          }}
      
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                //   label:'Anniversary Date',
                  style:{width : '100%',marginBlock:2}
                },
              }}
            />
          </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
             <CustomTextField id="noofchild" value={formik.values.noofchild} title="No Of Child" multiple={false} placeholder="Enter No of child" onchange={formik.handleChange} errorMsg={ formik.touched.noofchild &&  Boolean(formik.errors.noofchild) } helperText={formik.touched.noofchild && formik.errors.noofchild}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <CustomTextField id="balpoint" value={formik.values.balpoint} title="Balance Point" multiple={false} placeholder="balance point" onchange={formik.handleChange} errorMsg={ formik.touched.balpoint &&  Boolean(formik.errors.balpoint) } helperText={formik.touched.balpoint && formik.errors.balpoint}/>

                    {/* <Typography variant='body1' fontSize={20} fontWeight={600} mb={0.8}  >Balance Point: {balance || '0'}</Typography> */}
                    {/* <Typography variant="body1" fontSize={20} fontWeight={600} mb={0.8}>
  Balance Point: {formik.values.balpoint || '0'}
</Typography> */}
             {/* <CustomTextField id="balpoint" value={formik.values.balpoint} title="Balance Point" multiple={false} placeholder="Enter Balance point" onchange={formik.handleChange} errorMsg={ formik.touched.balpoint &&  Boolean(formik.errors.balpoint) } helperText={formik.touched.balpoint && formik.errors.balpoint}  readOnly={true}/> */}
            </Grid>
          
          <Grid item xs={12} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
                    </Grid>
         
            
          </Grid>
        </Modal>
      } 
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Grid>
  );
};

export default MemberList;
